(function(){
  const parts = window.TJAT100Parts || [];
  const assemblyMeta = window.TJAT100Assemblies || {};

  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const groupMeta = {
      spray: {
        title:'Spray System',
        image:'https://cdn.shopify.com/s/files/1/0562/3726/0846/files/t100-parts-spray.webp?v=1787319968',
        alt:'DJI Agras T100 spray system parts diagrams and component photos'
      },
      spread: {
        title:'Spreading System',
        image:'https://cdn.shopify.com/s/files/1/0562/3726/0846/files/t100-parts-spread.webp?v=1787319980',
        alt:'DJI Agras T100 spreading system parts diagrams and component photos'
      },
      frame: {
        title:'Airframe & Propulsion',
        image:'https://cdn.shopify.com/s/files/1/0562/3726/0846/files/t100-parts-frame.webp?v=1787319989',
        alt:'DJI Agras T100 airframe propulsion and structural parts diagrams and component photos'
      },
      lift: {
        title:'Dual-Battery Lift',
        image:'https://cdn.shopify.com/s/files/1/0562/3726/0846/files/t100-parts-lift.webp?v=1787320001',
        alt:'DJI Agras T100 dual battery lifting system parts diagrams and component photos'
      }
    };

    const search = root.querySelector('.t100parts__search');
    const clear = root.querySelector('.t100parts__clear');
    const assembly = root.querySelector('[data-t100-assembly]');
    const rows = root.querySelector('[data-t100-rows]');
    const count = root.querySelector('[data-t100-count]');
    const empty = root.querySelector('[data-t100-empty]');
    const more = root.querySelector('[data-t100-more]');
    const searchMode = root.querySelector('[data-t100-searchmode]');
    const termNode = root.querySelector('[data-t100-term]');
    const diagram = root.querySelector('[data-t100-diagram]');
    const diagramPanel = root.querySelector('.t100parts__diagramPanel');
    const hotspots = root.querySelector('[data-t100-hotspots]');
    const groupTitle = root.querySelector('[data-t100-group-title]');
    const diagramSub = root.querySelector('[data-t100-diagram-sub]');
    const modal = root.querySelector('[data-t100-modal]');
    const modalImage = root.querySelector('[data-t100-modal-image]');
    const modalTitle = root.querySelector('[data-t100-modal-title]');
    const modalHotspots = root.querySelector('[data-t100-modal-hotspots]');
    const toast = root.querySelector('[data-t100-toast]');
    const pageSize = 35;

    let visible = pageSize;
    let activeGroup = 'spray';
    let activeAssembly = '';
    let selectedItem = '';
    let current = [];

    function norm(s){
      return String(s || '').toLowerCase().replace(/[()–—/_.,-]/g,' ').replace(/\s+/g,' ').trim();
    }

    function escapeHtml(s){
      return String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
    }

    function uniqueAssemblies(group){
      return [...new Set(parts.filter(p => p.g === group).map(p => p.a))];
    }

    function getAssemblyMeta(){
      return activeAssembly ? assemblyMeta[activeAssembly] : null;
    }

    function currentDiagramMeta(){
      const exact = getAssemblyMeta();
      if (exact && exact.image) {
        return {
          title: activeAssembly,
          image: exact.image,
          alt: 'DJI Agras T100 ' + activeAssembly + ' parts diagram',
          hotspots: exact.hotspots || []
        };
      }
      return {
        title: groupMeta[activeGroup].title,
        image: groupMeta[activeGroup].image,
        alt: groupMeta[activeGroup].alt,
        hotspots: []
      };
    }

    function fillAssemblies(){
      const list = uniqueAssemblies(activeGroup);
      assembly.innerHTML = '<option value="">All ' + groupMeta[activeGroup].title.toLowerCase() + ' assemblies</option>' +
        list.map(a => '<option value="' + escapeHtml(a) + '">' + escapeHtml(a) + '</option>').join('');
      assembly.value = activeAssembly || '';
    }

    function setGroup(group, options){
      options = options || {};
      activeGroup = group;
      if (!options.keepAssembly) activeAssembly = '';
      if (!options.keepSelection) selectedItem = '';

      root.querySelectorAll('[data-group]').forEach(btn => {
        const on = btn.dataset.group === group;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      fillAssemblies();
      visible = pageSize;
      if (!options.keepSearch) {
        search.value = '';
        clear.hidden = true;
      }
      updateDiagram();
      render();
    }

    function matchesSearch(p, q){
      if (!q) return true;
      const hay = norm([p.m,p.n,p.a,groupMeta[p.g].title,p.i].join(' '));
      const words = norm(q).split(' ').filter(Boolean);
      return words.every(w => hay.includes(w));
    }

    function filtered(){
      const q = search.value.trim();
      if (q) return parts.filter(p => matchesSearch(p,q));
      return parts.filter(p => p.g === activeGroup && (!activeAssembly || p.a === activeAssembly));
    }

    function requestUrl(p){
      const params = new URLSearchParams();
      params.set('part', p.m);
      params.set('name', p.n);
      params.set('assembly', p.a);
      params.set('item', p.i);
      return '/pages/contact?' + params.toString();
    }

    function isSelected(p){
      return !!selectedItem && p.g === activeGroup && p.a === activeAssembly && String(p.i) === String(selectedItem);
    }

    function rowHtml(p){
      const selected = isSelected(p);
      return '<tr data-part-row data-group="' + escapeHtml(p.g) + '" data-assembly="' + escapeHtml(p.a) + '" data-item="' + escapeHtml(p.i) + '"' + (selected ? ' class="is-selected"' : '') + '>' +
        '<td class="t100parts__item"><button type="button" class="t100parts__itemLink" data-row-item="' + escapeHtml(p.i) + '" data-row-assembly="' + escapeHtml(p.a) + '" data-row-group="' + escapeHtml(p.g) + '" title="Show item ' + escapeHtml(p.i) + ' on the diagram">' + escapeHtml(p.i) + '</button></td>' +
        '<td><span class="t100parts__material">' + escapeHtml(p.m) + '</span></td>' +
        '<td class="t100parts__partName">' + escapeHtml(p.n) + '</td>' +
        '<td class="t100parts__assembly">' + escapeHtml(p.a) + (search.value.trim() ? '<br><small>' + escapeHtml(groupMeta[p.g].title) + '</small>' : '') + '</td>' +
        '<td><div class="t100parts__actions">' +
          '<button type="button" class="t100parts__diagramAction" data-view-part data-view-group="' + escapeHtml(p.g) + '" data-view-assembly="' + escapeHtml(p.a) + '" data-view-item="' + escapeHtml(p.i) + '">View Diagram</button>' +
          '<button type="button" class="t100parts__copy" data-copy="' + escapeHtml(p.m) + '">Copy #</button>' +
          '<a class="t100parts__request" href="' + requestUrl(p) + '">Request Part</a>' +
        '</div></td>' +
      '</tr>';
    }

    function render(){
      current = filtered();
      count.textContent = current.length;
      const q = search.value.trim();
      clear.hidden = !q;
      searchMode.hidden = !q;
      if (q) {
        termNode.textContent = '“' + q + '”';
        assembly.disabled = true;
      } else {
        assembly.disabled = false;
      }

      const shown = current.slice(0, visible);
      rows.innerHTML = shown.map(rowHtml).join('');
      empty.hidden = current.length !== 0;
      more.hidden = current.length <= visible;
      more.textContent = 'Show more parts (' + Math.max(0, current.length - visible) + ' remaining)';
    }

    function hotspotHtml(h, modalMode){
      const selected = activeAssembly && String(h.i) === String(selectedItem);
      return '<button type="button" class="t100parts__hotspot' + (selected ? ' is-selected' : '') + '" data-hotspot-item="' + escapeHtml(h.i) + '" style="left:' + Number(h.x).toFixed(2) + '%;top:' + Number(h.y).toFixed(2) + '%" aria-label="Item ' + escapeHtml(h.i) + '" title="Item ' + escapeHtml(h.i) + '">' + escapeHtml(h.i) + '</button>';
    }

    function renderHotspots(target, list){
      if (!target) return;
      target.innerHTML = (list || []).map(h => hotspotHtml(h)).join('');
      target.hidden = !(list && list.length);
    }

    function updateDiagram(){
      const meta = currentDiagramMeta();
      groupTitle.textContent = meta.title;
      diagram.src = meta.image;
      diagram.alt = meta.alt;
      diagramSub.textContent = activeAssembly ? groupMeta[activeGroup].title : 'Choose an assembly to open its exact diagram';
      renderHotspots(hotspots, meta.hotspots);
    }

    function findPart(group, assemblyName, item){
      return parts.find(p => p.g === group && p.a === assemblyName && String(p.i) === String(item));
    }

    function ensurePartVisible(part){
      const list = parts.filter(p => p.g === part.g && p.a === part.a);
      const idx = list.findIndex(p => String(p.i) === String(part.i) && p.m === part.m);
      if (idx >= 0 && idx + 1 > visible) visible = idx + 1;
    }

    function focusRow(part, scroll){
      const matching = [...rows.querySelectorAll('[data-part-row]')].find(row =>
        row.dataset.group === part.g && row.dataset.assembly === part.a && String(row.dataset.item) === String(part.i)
      );
      if (!matching) return;
      matching.classList.add('is-selected');
      if (scroll) matching.scrollIntoView({behavior:'smooth', block:'center'});
    }

    function goToPart(group, assemblyName, item, destination){
      const part = findPart(group, assemblyName, item);
      if (!part) return;

      search.value = '';
      activeGroup = group;
      activeAssembly = assemblyName;
      selectedItem = String(item);

      root.querySelectorAll('[data-group]').forEach(btn => {
        const on = btn.dataset.group === group;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      fillAssemblies();
      assembly.value = assemblyName;
      visible = pageSize;
      ensurePartVisible(part);
      updateDiagram();
      render();

      if (destination === 'row') {
        focusRow(part, true);
      } else {
        diagramPanel.scrollIntoView({behavior:'smooth', block:'start'});
      }
    }

    root.querySelectorAll('[data-group]').forEach(btn => {
      btn.addEventListener('click', () => setGroup(btn.dataset.group));
    });

    assembly.addEventListener('change', () => {
      activeAssembly = assembly.value;
      selectedItem = '';
      visible = pageSize;
      updateDiagram();
      render();
    });

    search.addEventListener('input', () => {
      selectedItem = '';
      visible = pageSize;
      render();
    });

    clear.addEventListener('click', () => {
      search.value = '';
      selectedItem = '';
      visible = pageSize;
      render();
      search.focus();
    });

    root.querySelectorAll('[data-t100-example]').forEach(btn => {
      btn.addEventListener('click', () => {
        search.value = btn.dataset.t100Example;
        selectedItem = '';
        visible = pageSize;
        render();
        root.querySelector('[data-t100-browser]').scrollIntoView({behavior:'smooth',block:'start'});
      });
    });

    root.querySelector('[data-t100-exit-search]').addEventListener('click', () => {
      search.value = '';
      selectedItem = '';
      visible = pageSize;
      render();
    });

    more.addEventListener('click', () => {
      visible += pageSize;
      render();
    });

    rows.addEventListener('click', async (e) => {
      const view = e.target.closest('[data-view-part]');
      if (view) {
        goToPart(view.dataset.viewGroup, view.dataset.viewAssembly, view.dataset.viewItem, 'diagram');
        return;
      }

      const itemBtn = e.target.closest('[data-row-item]');
      if (itemBtn) {
        goToPart(itemBtn.dataset.rowGroup, itemBtn.dataset.rowAssembly, itemBtn.dataset.rowItem, 'diagram');
        return;
      }

      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      const value = btn.dataset.copy;
      try {
        await navigator.clipboard.writeText(value);
      } catch(err) {
        const area = document.createElement('textarea');
        area.value = value;
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        area.remove();
      }
      toast.textContent = value + ' copied';
      toast.hidden = false;
      clearTimeout(root._toastTimer);
      root._toastTimer = setTimeout(() => toast.hidden = true, 1700);
    });

    function hotspotClick(e, fromModal){
      const btn = e.target.closest('[data-hotspot-item]');
      if (!btn || !activeAssembly) return;
      const item = btn.dataset.hotspotItem;
      const part = findPart(activeGroup, activeAssembly, item);
      if (!part) return;
      if (fromModal) closeModal();
      goToPart(activeGroup, activeAssembly, item, 'row');
    }

    if (hotspots) hotspots.addEventListener('click', e => hotspotClick(e, false));
    if (modalHotspots) modalHotspots.addEventListener('click', e => hotspotClick(e, true));

    function openModal(){
      const meta = currentDiagramMeta();
      modalImage.src = meta.image;
      modalImage.alt = meta.alt;
      modalTitle.textContent = meta.title + ' — T100 Parts Diagram';
      renderHotspots(modalHotspots, meta.hotspots);
      modal.hidden = false;
      modal.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal(){
      modal.hidden = true;
      modal.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-t100-zoom]').forEach(btn => btn.addEventListener('click', openModal));
    root.querySelectorAll('[data-t100-close]').forEach(btn => btn.addEventListener('click', closeModal));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    fillAssemblies();
    updateDiagram();
    render();
  });
})();
